module.exports = __webpack_public_path__ + "img/CHL_malawi.c70d7f75.jpg";